"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSmartSupply = void 0;
var isSmartSupply = function (supply) {
    var _a, _b, _c;
    return !!(((_a = supply === null || supply === void 0 ? void 0 : supply.supplyPointInfo) === null || _a === void 0 ? void 0 : _a.meterType) &&
        (((_b = supply.supplyPointInfo) === null || _b === void 0 ? void 0 : _b.meterType.toLowerCase().startsWith('s1')) ||
            ((_c = supply.supplyPointInfo) === null || _c === void 0 ? void 0 : _c.meterType.toLowerCase().startsWith('s2'))));
};
exports.isSmartSupply = isSmartSupply;
